import {
    YYGL
} from '../constants/funcUrl'

const yyglMutation = {
  [YYGL.APPROVELLIST](state, data) {
    state.approvellist = data;
  },
  [YYGL.ENTERPRISE](state, data) {
    state.enterprise = data;
  },
  [YYGL.ENTERPRISELEARNS](state, data) {
    state.enterpriseLearns = data;
  },
  [YYGL.ENTERPRISETESTS](state, data) {
    state.enterpriseTests = data;
  },
  [YYGL.ENTERPRISEEMPLOYEES](state, data) {
    state.enterpriseEmployees = data;
  },
  [YYGL.ENTERPRISEZJYTESTDETAILS](state, data) {
    state.enterpriseZjyTestDetails = data;
  },
  [YYGL.ENTERPRISEZJYTESTEMPLOYEES](state, data) {
    state.enterpriseZjyTestEmployees = data;
  },
  [YYGL.ENTERPRISEZJYTESTEMPLOYEERECORD](state, data) {
    state.enterpriseZjyTestEmployeeRecord = data;
  },
  [YYGL.ENTERPRISEBDYTESTDETAILS](state, data) {
    state.enterpriseBdyTestDetails = data;
  },
  [YYGL.ENTERPRISEBDYTESTEMPLOYEES](state, data) {
    state.enterpriseBdyTestEmployees = data;
  },
  [YYGL.ENTERPRISEBDYTESTEMPLOYEERECORD](state, data) {
    state.enterpriseBdyTestEmployeeRecord = data;
  },

  [YYGL.ENTERPRISEDETAILS](state, data) {
    state.enterpriseDetails = data;
  },
  [YYGL.ENTERPRISEREGISTER](state, data) {
    state.enterpriseRegister = data;
  },
  [YYGL.ENTERPRISEAPPROVE](state, data) {
    state.enterpriseApprove = data;
  },
  [YYGL.LEARNLEARNAPPROVE](state, data) {
    state.learnApprove = data;
  },
  [YYGL.LEARNLEARNCQJFAPPROVE](state, data) {
    state.learnExpirJfApprove = data;
  },
  [YYGL.LEARNLEARNAPPROVECOUNT1](state, data) {
    state.learnApproveCount1 = data;
  },
  [YYGL.LEARNLEARNAPPROVECOUNT2](state, data) {
    state.learnApproveCount2 = data;
  },
  [YYGL.LEARNLEARNAPPROVECOUNT3](state, data) {
    state.learnApproveCount3 = data;
  },
  [YYGL.LEARNJCYLEARNAPPROVECOUNT1](state, data) {
    state.jcyLearnApproveCount1 = data;
  },
  [YYGL.LEARNJCYLEARNAPPROVECOUNT2](state, data) {
    state.jcyLearnApproveCount2 = data;
  },
  [YYGL.MAKEUPMAKEUPAPPROVE](state, data) {
    state.makeUpApprove = data;
  },
  [YYGL.MAKEUPMAKEUPAPPROVECOUNT1](state, data) {
    state.makeUpApproveCount1 = data;
  },
  [YYGL.MAKEUPMAKEUPAPPROVECOUNT2](state, data) {
    state.makeUpApproveCount2 = data;
  },
  [YYGL.MAKEUPMAKEUPAPPROVECOUNT3](state, data) {
    state.makeUpApproveCount3 = data;
  },
  [YYGL.PENDINGAPPROVALCOUNT](state, data) {
    state.pendingApprovalCount = data;
  },
  [YYGL.LEARNINGMGTYY](state, data) {
    state.learningmgtYY = data;
  },
  [YYGL.LEARNINGMGT](state, data) {
    state.learningmgt = data;
  },
  [YYGL.LEARNINGMGTEMPLOYEE](state, data) {
    state.learningmgtEmployee = data;
  },
  [YYGL.LEARNINGMGTEMPLOYEEMOCKEXAMRECORDS](state, data) {
    state.learningmgtEmployeeMockExamRecords = data;
  },
  [YYGL.LEARNINGMGTEMPLOYEELESSON](state, data) {
    state.learningmgtEmployeeLesson = data;
  },
  [YYGL.LEARNINGMGTEMPLOYEELESSONCATALOGS](state, data) {
    state.learningmgtEmployeeLessonCatalogs = data;
  },
  [YYGL.LEARNINGMGTEMPLOYEELESSONALBUMDETAILS](state, data) {
    state.learningMGTEmployeeLessonAlbumDetails = data;
  },
  [YYGL.LEARNINGMGTEMPLOYEELESSONLOG](state, data) {
    state.learningmgtEmployeeLessonLog = data;
  },
  [YYGL.SEARCHEXPORTEMPLOYEE](state, data) {
    state.temployeeList = data;
  },
  [YYGL.SEARCHEXPORTJCY2026](state, data) {
    state.exportJcy2026Employees = data;
  },
  [YYGL.SEARCHEXPORTJCY2027](state, data) {
    state.exportJcy2027Employees = data;
  },
  [YYGL.EXPORTEMPLOYEEEXCEL](state, data) {
    state.exportEmployeeExcel = data;
  },
  [YYGL.LEARNAPPROVEEXPORTBDYEXCEL](state, data) {
    state.learnApproveExportBdyExcel = data;
  },
  [YYGL.LEARNAPPROVEEXPORTBDYZPZIP](state, data) {
    state.learnApproveExportBdyZpZip = data;
  },
  [YYGL.LEARNAPPROVEEXPORTBDYHZBEXCEL](state, data) {
    state.learnApproveExportBdyHzbExcel = data;
  },
  [YYGL.LEARNAPPROVEEXPORTJSGREXCEL](state, data) {
    state.learnApproveExportJsgrExcel = data;
  },
  [YYGL.LEARNENTERPRISE](state, data) {
    state.learnEnterprise = data;
  },
  [YYGL.EXPORTEMPLOYEEZP](state, data) {
    state.exportEmployeeZp = data;
  },
  [YYGL.EXPORTBDYEXCEL](state, data) {
    state.exportBdyExcel = data;
  },
  [YYGL.EXPORTJSGREXCEL](state, data) {
    state.exportJsgrExcel = data;
  },
  [YYGL.YYHASCOURSE](state, data) {
    state.yyHasCourse = data;
  },
  [YYGL.LEARNAPPROVEEXPORTEXCEL](state, data) {
    state.learnapproveExportExcel = data;
  },
  [YYGL.LEARNAPPROVEEXPORTEMPLOYEEEXCEL](state, data) {
    state.learnapproveExportEmployeeExcel = data;
  },
  [YYGL.LEARNEXPORTBDYBM](state, data) {
    state.learnBdyBMExcel = data;
  },
  [YYGL.MAKEUPAPPROVEEXPORTAPPROVEEXCEL](state, data) {
    state.exportMakeUpApproveExcel = data;
  },
  [YYGL.MAKEUPAPPROVEEXPORTJFAPPROVEEXCEL](state, data) {
    state.exportMakeUpjfApproveExcel = data;
  },
  [YYGL.TESTMGTROOMS](state, data) {
    state.testRooms = data;
  },
  [YYGL.TESTMGTROOM](state, data) {
    state.testRoom = data;
  },

  [YYGL.TESTMGTBATCHS](state, data) {
    state.testBatchs = data;
  },
  [YYGL.TESTMGTBATCHDETAILS](state, data) {
    state.testBatchDetails = data;
  },
  [YYGL.TESTMGTCOURSEBATCHS](state, data) {
    state.courseTestBatchs = data;
  },
  [YYGL.TESTMGTBATCHEMPLOYEES](state, data) {
    state.testBatchEmployees = data;
  },
  [YYGL.TESTMGTBATCHADDEMPLOYEES](state, data) {
    state.testBatchAddEmployees = data;
  },
  [YYGL.TESTMGTBATCHJOBSTATS](state, data) {
    state.testBatchJobStats = data;
  },
  [YYGL.TESTMGTBATCHEXPORTEMPLOYEEEXCEL](state, data) {
    state.testBatchEmployeeExcel = data;
  },

  [YYGL.TESTMGTTRAINS](state, data) {
    state.testTrains = data;
  },
  [YYGL.TESTMGTCOURSETRAINS](state, data) {
    state.courseTestTrains = data;
  },
  [YYGL.TESTMGTTRAINDETAILS](state, data) {
    state.testTrainDetails = data;
  },
  [YYGL.TESTMGTTRAINEMPLOYEES](state, data) {
    state.testTrainEmployees = data;
  },
  [YYGL.TESTMGTTRAINEXPORTEMPLOYEEEXCEL](state, data) {
    state.testTrainEmployeeExcel = data;
  },
  [YYGL.TESTMGTTRAINEXPORTLESSONEXCEL](state, data) {
    state.testTrainLessonExcel = data;
  },
  [YYGL.TESTMGTTRAINEXPORTEMPLOYEEZP](state, data) {
    state.testTrainEmployeeZp = data;
  },

  [YYGL.TESTMGTSESSIONSTATES](state, data) {
    state.testSessionStates = data;
  },
  [YYGL.TESTMGTSESSIONS](state, data) {
    state.testSessions = data;
  },
  [YYGL.TESTMGTSESSIONDETAILS](state, data) {
    state.testSessionDetails = data;
  },
  [YYGL.TESTMGTSESSIONEMPLOYEES](state, data) {
    state.testSessionEmployees = data;
  },
  [YYGL.TESTMGTSESSIONEMPLOYEEADMISSIONTICKET](state, data) {
    state.testSessionEmployeeAdmissionTicketUrl = data;
  },
  [YYGL.TESTMGTSESSIONADDEMPLOYEES](state, data) {
    state.testSessionAddEmployees = data;
  },
  [YYGL.TESTMGTSESSIONEXPORTEMPLOYEEEXCEL](state, data) {
    state.testSessionEmployeeExcel = data;
  },
  [YYGL.TESTMGTSESSIONEXPORTTESTEXCEL](state, data) {
    state.testSessionTestExcel = data;
  },
  [YYGL.TESTMGTZJPXTRAINS](state, data) {
    state.zjpxTrains = data;
  },

  [YYGL.ZJYTESTMGTBATCHS](state, data) {
    state.zjyTestBatchs = data;
  },
  [YYGL.ZJYTESTMGTBATCHDETAILS](state, data) {
    state.zjyTestBatchDetails = data;
  },
  [YYGL.ZJYTESTMGTBATCHEMPLOYEES](state, data) {
    state.zjyTestBatchEmployees = data;
  },
  [YYGL.ZJYTESTMGTBATCHAPPROVEEMPLOYEES](state, data) {
    state.zjyTestBatchApproveEmployees = data;
  },
  [YYGL.ZJYTESTMGTBATCHAPPROVEEMPLOYEECOUNT](state, data) {
    state.zjyTestBatchApproveEmployeeCount = data;
  },

  [YYGL.ENTERPRISEENTERPRISES](state, data) {
    state.enterprises = data;
  },

  [YYGL.INVOICEAPPROVEYY](state, data) {
    state.invoiceApproves = data;
  },
  [YYGL.INVOICEAPPROVECOUNT1](state, data) {
    state.invoiceApproveCount1 = data;
  },
  [YYGL.INVOICEAPPROVECOUNT2](state, data) {
    state.invoiceApproveCount2 = data;
  },
  [YYGL.INVOICEAPPROVECOUNT3](state, data) {
    state.invoiceApproveCount3 = data;
  },
  [YYGL.INVOICEAPPROVECOUNT4](state, data) {
    state.invoiceApproveCount4 = data;
  },
  [YYGL.INVOICEAPPROVEMANDATORYLEARNS](state, data) {
    state.invoiceMandatoryLearns = data;
  },

  [YYGL.NEWSTESTPLAN](state, data) {
    state.newsTestPlan = data;
  },
  [YYGL.NEWSTESTPLANTYPES](state, data) {
    state.newsTestPlanTypes = data;
  },

  [YYGL.NEWSCATEGORYS](state, data) {
    state.newsCategorys = data;
  },
  [YYGL.NEWSYY](state, data) {
    state.newsYY = data;
  },

  [YYGL.EMPLOYEES](state, data) {
    state.employees = data;
  },
  [YYGL.EMPLOYEEDETAILS](state, data) {
    state.employeeDetails = data;
  },
  [YYGL.EMPLOYEEMNKSLEARNS](state, data) {
    state.employeeMnksLearns = data;
  },
  [YYGL.EMPLOYEELEARNS](state, data) {
    state.employeeLearns = data;
  },
  [YYGL.EMPLOYEETESTS](state, data) {
    state.employeeTests = data;
  },
  [YYGL.EMPLOYEEPRACTICES](state, data) {
    state.employeePractices = data;
  },

  [YYGL.CERT](state, data) {
    state.cert = data;
  },
  [YYGL.CERTCERTS](state, data) {
    state.certs = data;
  },
  [YYGL.CERTCERTSTATS](state, data) {
    state.certStats = data;
  },
  [YYGL.CERTCERTSOURCES](state, data) {
    state.certSources = data;
  },
  [YYGL.CERTDETAILS](state, data) {
    state.certDetails = data;
  },

  [YYGL.JSGRTESTMGTBATCHS](state, data) {
    state.jsgrTestBatchs = data;
  },
  [YYGL.JSGRTESTMGTALLBATCHS](state, data) {
    state.allJsgrTestBatchs = data;
  },
  [YYGL.JSGRTESTMGTBATCHJOBSTATS](state, data) {
    state.jsgrTestBatchJobStats = data;
  },
  [YYGL.JSGRTESTMGTBATCHEMPLOYEES](state, data) {
    state.jsgrTestBatchEmployees = data;
  },

  [YYGL.JSGRTESTMGTTRAINS](state, data) {
    state.jsgrTestTrains = data;
  },
  [YYGL.JSGRTESTMGTALLTRAINS](state, data) {
    state.allJsgrTestTrains = data;
  },
  [YYGL.JSGRTESTMGTTRAINEMPLOYEES](state, data) {
    state.jsgrTestTrainEmployees = data;
  },
  [YYGL.JSGRTESTMGTTRAINEMPLOYEEEXPORT](state, data) {
    state.jsgrTestTrainEmployeeExcel = data;
  },
  [YYGL.JSGRTESTMGTTRAINLESSONEXPORT](state, data) {
    state.jsgrTestTrainLessonExcel = data;
  },

  [YYGL.JSGRTESTMGTSESSIONS](state, data) {
    state.jsgrTestSessions = data;
  },
  [YYGL.JSGRTESTMGTSESSIONDETAILS](state, data) {
    state.jsgrTestSessionDetails = data;
  },
  [YYGL.JSGRTESTMGTSESSIONEMPLOYEES](state, data) {
    state.jsgrTestSessionEmployees = data;
  },
  [YYGL.JSGRTESTMGTSESSIONADDEMPLOYEES](state, data) {
    state.addJsgrTestSessionEmployees = data;
  },
  [YYGL.JSGRTESTMGTSESSIONSCOREEXPORT](state, data) {
    state.jsgrTestSessionEmployeeExcel = data;
  },

  [YYGL.TESTMGTPLANBATCHS](state, data) {
    state.bdyTestPlanBatchs = data;
  },
  [YYGL.TESTMGTPLANBATCHJOBSTATS](state, data) {
    state.bdyTestPlanBatchJobStats = data;
  },
  [YYGL.TESTMGTPLANBATCHSESSIONS](state, data) {
    state.bdyTestPlanBatchSessions = data;
  },

  [YYGL.BDYTESTMGTBATCHS](state, data) {
    state.bdyTestBatchs = data;
  },
  [YYGL.BDYTESTMGTBATCHJOBSTATS](state, data) {
    state.bdyTestBatchJobStats = data;
  },
  [YYGL.BDYTESTMGTBATCHDETAILS](state, data) {
    state.bdyTestBatchDetails = data;
  },
  [YYGL.BDYTESTMGTBATCHEEMPLOYEEEXPORT](state, data) {
    state.bdyTestBatchEmployeeExcel = data;
  },

  [YYGL.BDYTESTMGTSESSIONS](state, data) {
    state.bdyTestSessions = data;
  },
  [YYGL.BDYTESTMGTSESSIONJOBSTATS](state, data) {
    state.bdyTestSessionJobStats = data;
  },
  [YYGL.BDYTESTMGTSESSIONDETAILS](state, data) {
    state.bdyTestSessionDetails = data;
  },
  [YYGL.BDYTESTMGTSESSIONEMPLOYEES](state, data) {
    state.bdyTestSessionEmployees = data;
  },
  [YYGL.BDYTESTMGTSESSIONKCYBEXPORT](state, data) {
    state.bdyTestSessionKcybExcel = data;
  },
  [YYGL.BDYTESTMGTSESSIONEMPLOYEEEXPORT](state, data) {
    state.bdyTestSessionEmployeeExcel = data;
  },

  [YYGL.EXAMBATCHS](state, data) {
    state.examBatchs = data;
  },
  [YYGL.EXAMBATCHCOURSES](state, data) {
      state.examBatchCourses = data;
  },
  [YYGL.EXAMBATCHJOBSTATS](state, data) {
    state.examBatchJobStats = data;
  },
  [YYGL.EXAMBATCHDETAILS](state, data) {
    state.examBatchDetails = data;
  },
  [YYGL.EXAMBATCHEEMPLOYEEEXPORT](state, data) {
    state.examBatchEmployeeExcel = data;
  },
  [YYGL.EXAMBATCHSPBEXPORT](state, data) {
    state.examBatchSpbExcel = data;
  },

  [YYGL.EXAMSESSIONS](state, data) {
    state.examSessions = data;
  },
  [YYGL.EXAMSESSIONCOURSES](state, data) {
      state.examSessionCourses = data;
  },
  [YYGL.EXAMSESSIONJOBSTATS](state, data) {
    state.examSessionJobStats = data;
  },
  [YYGL.EXAMSESSIONDETAILS](state, data) {
    state.examSessionDetails = data;
  },
  [YYGL.EXAMSESSIONEMPLOYEES](state, data) {
    state.examSessionEmployees = data;
  },
  [YYGL.EXAMSESSIONKCYBEXPORT](state, data) {
    state.examSessionKcybExcel = data;
  },
  [YYGL.EXAMSESSIONEMPLOYEEEXPORT](state, data) {
    state.examSessionEmployeeExcel = data;
  },
  [YYGL.EXAMSESSIONSCORETPLEXPORT](state, data) {
    state.examSessionScoreTemplateExcel = data;
  },
  [YYGL.EXAMPAPERDETAILS](state, data) {
    state.examPaperDetails = data;
  },
  [YYGL.EXAMPAPERAPPROVES](state, data) {
    state.examPaperApproves = data;
  },
  [YYGL.EXAMSESSIONEMPLOYEECERT](state, data) {
    state.examSessionEmployeeCert = data;
  },

  [YYGL.ENTERPRISEMODIFYAPPROVESYY](state, data) {
    state.enterpriseModifyApprovesYY = data;
  },
  [YYGL.ENTERPRISEPENDINGMODIFYAPPROVALCOUNT](state, data) {
    state.pendingModifyApprovalCount = data;
  },

  [YYGL.BDYPRACTICEENROLLS](state, data) {
    state.bdyPracticeEnrolls = data;
  },
  [YYGL.BDYPRACTICEENROLLAPPROVALCOUNT](state, data) {
    state.bdyPracticeEnrollApprovalCount = data;
  },
  [YYGL.BDYPRACTICEENROLLSTATES](state, data) {
    state.gbdyPracticeEnrollStates = data;
  },
  [YYGL.BDYPRACTICEENROLLDETAILS](state, data) {
    state.bdyPracticeEnrollDetails = data;
  },

  [YYGL.QUESTIONQUESTIONS](state, data) {
    state.questionYYs = data;
  },

  [YYGL.QUESTIONBDYQUESTIONS](state, data) {
    state.bdyQuestions = data;
  },

  [YYGL.LEARNINVOICELEARNINVOICES](state, data) {
    state.learnInvoices = data;
  },
  [YYGL.LEARNINVOICEGKDKPCOUNT](state, data) {
    state.learnInvoiceGkDKPCount = data;
  },
  [YYGL.LEARNINVOICEPXDKPCOUNT](state, data) {
    state.learnInvoicePxDKPCount = data;
  },
  [YYGL.LEARNINVOICEDETAILS](state, data) {
    state.learnInvoiceDetails = data;
  },
  [YYGL.LEARNINVOICESTATES](state, data) {
    state.learnInvoiceStates = data;
  },
  [YYGL.LEARNINVOICEEXPERTDPWJ](state, data) {
    state.learnInvoiceDpwj = data;
  },
  [YYGL.LEARNINVOICEEXPERTDPEXCEL](state, data) {
    state.learnInvoiceDpExcel = data;
  },

  [YYGL.CERTREPLACEAPPROVECERTREPLACES](state, data) {
    state.approveCertReplaces = data;
  },
  [YYGL.CERTREPLACEAPPROVES](state, data) {
    state.certReplaceApproves = data;
  },
  [YYGL.CERTREPLACEAPPROVECERTREPLACECOUNT1](state, data) {
    state.approveCertReplaceCount1 = data;
  },
  [YYGL.CERTREPLACEAPPROVECERTREPLACECOUNT2](state, data) {
    state.approveCertReplaceCount2 = data;
  },
  [YYGL.CERTREPLACEAPPROVEACTIONS](state, data) {
    state.certReplaceApproveActions = data;
  },

  [YYGL.EMPLOYEECHANGEAPPROVEALL](state, data) {
    state.allEmployeeChangeApproves = data;
  }
};

export default yyglMutation;



// WEBPACK FOOTER //
// ./src/store/jzjy/mutations/yyglMutation.js